import { IDoctor } from "../../interfaces/api";

const DoctorTile = ({
  data,
  handleViewMedicalGroups,
}: {
  data: IDoctor;
  handleViewMedicalGroups: (doctor: IDoctor) => void;
}) => {
  const nearestLocation = data.ahRecords.map((record) => ({
    ...record,
    addresses: [...record.addresses].sort(
      (a, b) => a.distanceFromGivenAddress - b.distanceFromGivenAddress
    ),
  }));
  const nearestFromAllLocations = nearestLocation.sort(
    (a, b) =>
      a.addresses[0].distanceFromGivenAddress -
      b.addresses[0].distanceFromGivenAddress
  );

  const minDistanceLocation =
    nearestFromAllLocations.length > 0
      ? nearestFromAllLocations[0].addresses[0]
      : null;

  const allAddresses = data.ahRecords.flatMap((record) =>
    record.addresses.map((address) => address.address1)
  );

  const allGroups = data.ahRecords.flatMap((record) => record.medGrpNetwork);

  return (
    <>
      <div
        className="hide-for-small-only"
        style={{
          border: "1px solid #1B54C2",
          margin: "4px",
          width: " 48%",
          justifyContent: "space-between",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={() => handleViewMedicalGroups(data)}
      >
        <div style={{ padding: "16px" }}>
          <h3
            className="primary-color"
            style={{
              fontSize: "22px",
              paddingBottom: "16px",
              textAlign: "left",
            }}
          >
            {data.nppes.firstName} {data.nppes.lastName}, {data.nppes.suffix}
          </h3>
          <div style={{ paddingBottom: "6px", textAlign: "left" }}>
            <span style={{ fontWeight: 600 }}>NPI:</span> {data.npi}
          </div>
          <div style={{ paddingBottom: "6px", textAlign: "left" }}>
            <span style={{ fontWeight: 600 }}>Speciality:</span>{" "}
            {data.specialities[0].desc}
          </div>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontWeight: 600 }}>Nearest location:</span>{" "}
            {minDistanceLocation?.standardized.address1}
            {!!minDistanceLocation?.standardized.address2
              ? ` ${minDistanceLocation.standardized.address2}, `
              : ", "}
            {minDistanceLocation?.standardized.city},{" "}
            {minDistanceLocation?.standardized.state}{" "}
            {minDistanceLocation?.standardized.zip5}
          </div>
        </div>
        <div
          className="primary-color"
          style={{
            backgroundColor: "#F5F9FD",
            padding: "4px",
            display: "flex",
            columnGap: "28px",
            justifyContent: "flex-end",
          }}
        >
          <div style={{ fontSize: "22px" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={
                  (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
                  "/add_box.svg"
                }
                alt="Vector"
              />
              <div>{allGroups.length}</div>
            </div>
            <div style={{ fontSize: "16px" }}>Groups</div>
          </div>
          <div style={{ fontSize: "22px" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={
                  (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
                  "/town.svg"
                }
                alt="Vector"
              />
              <div>{allAddresses.length}</div>
            </div>
            <div style={{ fontSize: "16px" }}>Locations</div>
          </div>
          <div style={{ fontSize: "22px" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={
                  (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
                  "/location.svg"
                }
                alt="Vector"
              />
              <div>
                {minDistanceLocation?.distanceFromGivenAddress.toFixed(2)}
              </div>
            </div>
            <div style={{ fontSize: "16px" }}>Miles Away</div>
          </div>
        </div>
      </div>
      <div
        className="show-for-small-only small-12"
        style={{
          border: "1px solid #1B54C2",
          marginBottom: "4px",
          justifyContent: "space-between",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={() => handleViewMedicalGroups(data)}
      >
        <div style={{ padding: "16px" }}>
          <h3
            className="primary-color"
            style={{
              fontSize: "22px",
              paddingBottom: "16px",
              textAlign: "left",
            }}
          >
            {data.nppes.firstName} {data.nppes.lastName}, {data.nppes.suffix}
          </h3>
          <div style={{ paddingBottom: "6px", textAlign: "left" }}>
            <span style={{ fontWeight: 600 }}>NPI:</span> {data.npi}
          </div>
          <div style={{ paddingBottom: "6px", textAlign: "left" }}>
            <span style={{ fontWeight: 600 }}>Speciality:</span>{" "}
            {data.specialities[0].desc}
          </div>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontWeight: 600 }}>Nearest location:</span>{" "}
            {minDistanceLocation?.standardized.address1}
            {!!minDistanceLocation?.standardized.address2
              ? ` ${minDistanceLocation.standardized.address2}, `
              : ", "}
            {minDistanceLocation?.standardized.city},{" "}
            {minDistanceLocation?.standardized.state}{" "}
            {minDistanceLocation?.standardized.zip5}
          </div>
        </div>
        <div
          className="primary-color"
          style={{
            backgroundColor: "#F5F9FD",
            padding: "4px",
            display: "flex",
            columnGap: "28px",
            justifyContent: "flex-end",
          }}
        >
          <div style={{ fontSize: "22px" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={
                  (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
                  "/add_box.svg"
                }
                alt="Vector"
              />
              <div>{allGroups.length}</div>
            </div>
            <div style={{ fontSize: "16px" }}>Groups</div>
          </div>
          <div style={{ fontSize: "22px" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={
                  (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
                  "/town.svg"
                }
                alt="Vector"
              />
              <div>{allAddresses.length}</div>
            </div>
            <div style={{ fontSize: "16px" }}>Locations</div>
          </div>
          <div style={{ fontSize: "22px" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={
                  (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
                  "/location.svg"
                }
                alt="Vector"
              />
              <div>
                {minDistanceLocation?.distanceFromGivenAddress.toFixed(2)}
              </div>
            </div>
            <div style={{ fontSize: "16px" }}>Miles Away</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorTile;
